import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { removeClassFromUser, addClassToUser, getReviewingStudentEvaluations, getClassesAssignments, setAssignment, getClassesSprints, getClassesFromIds, setSprint, getClassStudents, getSprintEvaluations, getPossibleClasses, setEvaluation, fetchServerTime } from '../../redux';
import Tile from '../Components/Tile';
import ClassMenu from '../Components/ClassMenu';
import { Link, useNavigate } from 'react-router-dom';
import '../Components/dashboard.css';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import pluralize from '../../lib/pluralize';

function Student (props) {
    const {
        getReviewingStudentEvaluations,
        getClassesAssignments,
        getClassesSprints,
        getClassesFromIds,
        getPossibleClasses,
        setAssignment,
        setSprint,
        getClassStudents,
        setEvaluation,
        getSprintEvaluations,
        classes,
        classAssignments,
        sprints,
        reviewingEvaluations,
        user,
        addClassToUser,
        removeClassFromUser,
        possibleClasses,
        serverTimeAsUtcISO, 
        fetchServerTime
    } = props;

    const navigate = useNavigate();

    const [classIndex, setClassIndex] = useState(0);
    const [isViewingClassMenu, setIsViewingClassMenu] = useState(false);
    const [addClicked, setAddClicked] = useState(false);
    const [showRemoveDialog, setShowRemoveDialog] = useState(false);
    const [classToRemove, setClassToRemove] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        getReviewingStudentEvaluations(user._id);
        fetchServerTime();
        getClassesAssignments(user.classes);
        getClassesSprints(user.classes);
        getClassesFromIds(user.classes);
        getPossibleClasses(user.school);
    }, []);

    const handleAddClick = () => {
        setAddClicked(!addClicked);
    }

    const toggleClassMenu = () => {
        setIsViewingClassMenu(!isViewingClassMenu);
        setAddClicked(false);
    }

    const setAssignmentSprintAndRedirect = (assignment, sprint, classId) => {
        setAssignment(assignment);
        setSprint(sprint)
        getClassStudents(classId);
        navigate("/evaluation/new");
    }

    const setClassStudentsAndRedirect = (classId) => {
        getClassStudents(classId);
        navigate("/evaluation/extra");
    }

    const setAssignmentSprintEvaluationAndRedirect = (assignment, sprint, evaluation) => {
        setAssignment(assignment);
        setSprint(sprint);
        setEvaluation(evaluation);
        navigate("/evaluation/edit");
    }

    const setSprintAndRedirect = (sprint) => {
        getSprintEvaluations(sprint._id, user._id);
        setSprint(sprint);
        navigate("/student/reviews");
    }

    const handleDropdownChange = (e) => {
        setClassIndex(classes.findIndex(classObject => classObject.name.trim() === e.target.innerText.trim()));
    }

    const handleClassIndexChange = (number) => {
        setClassIndex(number);
    }

    const getMappedClassOptions = () => {
        return classes && classes
                  .map((classObject, index) => {
                      return (
                          <MenuItem
                              key={index + classObject.name}
                              value={classObject.name}
                              primaryText={classObject.name}
                              id="class"
                          />
                      );
                  });
    }

    const calculateIfOnTime = (dueDate) => {
        const assignmentDueDate = new Date(dueDate);
        const currentDateObject = new Date(serverTimeAsUtcISO || new Date());
        assignmentDueDate.setHours(0, 0, 0, 0);
        assignmentDueDate.setDate(assignmentDueDate.getDate() + 1);
        return currentDateObject <= assignmentDueDate;
    }

    const calculateReviewsToDo = (classId, evaluations) => {
        const assignments = classAssignments && classAssignments
            .filter(assignment => assignment.class === classId)
            .sort((a, b) => {
                if (a.dueDate < b.dueDate) return -1;
                if (a.dueDate > b.dueDate) return 1;
                return 0;
            });

        const sprint = sprints.find(sprint => sprint.class === classId) || {pointsForDoingEvaluation: 0};
        let assignmentEvaluations = [];
        let newEvaluationsToDo = [];
        let date;

        for (let assignment of (assignments && assignments.filter(assignment => assignment.status === "Assigned"))) {
            assignmentEvaluations = evaluations && evaluations.filter(evaluation => evaluation.assignment === assignment._id);
            for (let i = 0; i < assignment.evaluationsRequired - assignmentEvaluations.length; i++) {
                if (calculateIfOnTime(assignment.dueDate)) {
                    date = assignment.dueDate.slice(5, 10).replace("-", "/");
                    if (date[0] === "0") {
                        date = date.slice(1);
                    }
                    newEvaluationsToDo.push({
                        number: `Review ${i + 1}`,
                        name: assignment.name,
                        dueDate: `Due ${date}`,
                        status: "Complete the Review",
                        grade: `? out of 3`,
                        assignment,
                        sprint: sprints.find(sprint => sprint._id === assignment.sprint),
                        classId: sprint.class
                    })
                }
            }
        }

        const submittedEvaluations = evaluations && evaluations.filter(evaluation => evaluation.status === "TeacherSubmittedReleased");
        let evaluationsToEdit = [];
        for (let assignment of (assignments && assignments.filter(assignment => assignment.status === "Reviewed" || assignment.status === "Assigned"))) {
            assignmentEvaluations = submittedEvaluations && submittedEvaluations.filter(evaluation => evaluation.assignment === assignment._id);
            for (let i = 0; i < assignmentEvaluations.length; i++) {
                date = assignment.dueDate.slice(5, 10).replace("-", "/");
                if (date[0] === "0") {
                    date = date.slice(1);
                }
                evaluationsToEdit.push({
                    number: `Review ${i + 1}`,
                    name: assignment.name,
                    dueDate: `Due ${date}`,
                    status: "Edit the Review",
                    grade: assignmentEvaluations[i].teacherGrade
                        ? `${assignmentEvaluations[i].teacherGrade} out of 3`
                        : 'Ungraded',
                    assignment,
                    sprint: sprints.find(sprint => sprint._id === assignment.sprint),
                    classId: sprint.class,
                    evaluation: assignmentEvaluations[i],
                    allowResubmissions: assignment.allowResubmissions
                });
            }
        }

        let numberOfSubmittedEvaluations = 0;
        let totalNumberOfEvaluations = 0;
        for (let assignment of (assignments && assignments.filter(assignment => assignment.status !== "Inactive"))) {
            totalNumberOfEvaluations += assignment.evaluationsRequired;
            assignmentEvaluations = evaluations && evaluations.filter(evaluation => evaluation.assignment === assignment._id);
            if (assignmentEvaluations) {
                if (assignmentEvaluations.length >= assignment.evaluationsRequired) {
                    numberOfSubmittedEvaluations += assignment.evaluationsRequired;
                } else {
                    numberOfSubmittedEvaluations += assignmentEvaluations.length;
                }
            }
        }

        return {newEvaluationsToDo, evaluationsToEdit, totalNumberOfEvaluations, numberOfSubmittedEvaluations};
    }

    const mapNewReviews = (evaluations) => {
        return evaluations.map((evaluation, index) => {
            return (
                <div className="tileContainer" key={index + "newTileContainer"}>
                    <Tile
                        key={index + "newTile"}
                        number={evaluation.number}
                        name={evaluation.name}
                        status={evaluation.status}
                        dueDate={evaluation.dueDate}
                        grade={evaluation.grade}
                        handleClick={() => setAssignmentSprintAndRedirect(evaluation.assignment, evaluation.sprint, evaluation.classId)}
                    />
                </div>
            )
        });
    }

    const mapEditReviews = (evaluations) => {
        return evaluations.map((evaluation, index) => {
            return (
                <div className="tileContainer" key={index + "editTileContainer"}>
                    <Tile
                        assignment={evaluation.assignment}
                        key={index + "editTile"}
                        number={evaluation.number}
                        name={evaluation.name}
                        status={evaluation.status}
                        dueDate={evaluation.dueDate}
                        grade={evaluation.grade}
                        handleClick={() => setAssignmentSprintEvaluationAndRedirect(evaluation.assignment, evaluation.sprint, evaluation.evaluation)}
                    />
                </div>
            )
        });
    }

    const getMappedReports = (classObject) => {
        let date;
        return sprints && sprints
            .filter(sprint => sprint.status === "Released")
            .map((sprint, index) => {
                date = sprint.releaseDate ? sprint.releaseDate.slice(5, 10).replace("-", "/") : "";
                if (date.length > 0 && date[0] === "0") {
                    date = date.slice(1);
                }
                return (
                    <div className="tileContainer" key={index + "sprintTileContainer"}>
                        <Tile
                            key={index + "sprintTile"}
                            number={sprint.name}
                            status={`Released ${date}`}
                            handleClick={() => setSprintAndRedirect(sprint)}
                        />
                    </div>
                )
        });
    }

    const getGrades = (grade, evaluations) => {
        if (evaluations && evaluations.length !== 0) {
            for (let evaluation of evaluations) {
                if (evaluation.teacherGrade !== undefined) {
                    grade.numerator += evaluation.teacherGrade;
                    grade.denominator += 3;
                }
            }
            grade.percent = Math.floor(grade.numerator/grade.denominator * 10000) / 100 || "N/A";
        }
    }

    const classObject = classes[classIndex] || {name: ""}
    const evaluations = reviewingEvaluations && reviewingEvaluations
        .filter(evaluation => evaluation.class === classObject._id);

    const grade = {numerator: 0, denominator: 0, percent: 100}
    getGrades(grade, evaluations);

    const evaluationsToDo = calculateReviewsToDo(classObject._id, evaluations);
    const evaluationsNumbers = evaluationsToDo.evaluationsToEdit.length + evaluationsToDo.newEvaluationsToDo.length;
    const totalNumberOfEvaluations = evaluationsToDo.totalNumberOfEvaluations;
    const numberOfSubmittedEvaluations = evaluationsToDo.numberOfSubmittedEvaluations || 0;

    let evaluationsLeftText;
    const evaluationsToResubmit = evaluationsToDo.evaluationsToEdit.filter(evaluation => evaluation.allowResubmissions);
    if (evaluationsNumbers === 0) {
        evaluationsLeftText = `You have submitted all available evaluations.`;
    } else {
        evaluationsLeftText = 'You have ';
        if (evaluationsToDo.newEvaluationsToDo.length > 0) {
            evaluationsLeftText += `${evaluationsToDo.newEvaluationsToDo.length} ${pluralize('review', evaluationsToDo.newEvaluationsToDo.length)} to submit`
            if (evaluationsToResubmit.length > 0) {
                evaluationsLeftText += ` and ${evaluationsToResubmit.length} ${pluralize('review', evaluationsToResubmit.length)} to resubmit`
            }
        } else if(evaluationsToResubmit.length > 0) {
            evaluationsLeftText += `${evaluationsToResubmit.length} ${pluralize('review', evaluationsToResubmit.length)} to resubmit`
        }
        evaluationsLeftText += '.'
    }

    if (sprints) {
        const reports = sprints.filter(sprint => sprint.status === "Released");
        if (reports && reports.length === 1) {
            evaluationsLeftText += ' 1 report is available.'
        } else if (reports && reports.length > 1) {
            evaluationsLeftText += ` ${reports.length} reports are available.`
        }
    }

    const pinkBarStyle = {width: `${numberOfSubmittedEvaluations/totalNumberOfEvaluations * 100}%`, zIndex: 1, boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.23), 0 1px 1px 0 rgba(0, 0, 0, 0.3)"};

    const handleRemoveClick = (userId, classId) => {
        const classToRemoveData = classes.find(cls => cls._id === classId);
        setClassToRemove({ userId, classId, className: classToRemoveData?.name || 'Unknown Class' });
        setShowRemoveDialog(true);
    }

    const handleConfirmRemove = () => {
        if (classToRemove) {
            removeClassFromUser(classToRemove.userId, classToRemove.classId);
            // eslint-disable-next-line
            const newUserClasses = [...(user.classes || [])].filter(
                (id) => id !== classToRemove.classId
            );
            getClassesAssignments(newUserClasses);
            getClassesSprints(newUserClasses);
            getClassesFromIds(newUserClasses);
            setClassIndex(0);
            setShowRemoveDialog(false);
            setClassToRemove(null);
        }
    }

    const handleCancelRemove = () => {
        setShowRemoveDialog(false);
        setClassToRemove(null);
    }

    return (
        <div className="dashboard">
            <div className="classElement">
                <div className="classChoice">
                    <SelectField
                        name="class"
                        value={classObject.name}
                        onChange={handleDropdownChange}
                        iconStyle={{paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px"}}
                        style={{borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px"}}
                        labelStyle={{color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px"}}
                        underlineStyle={{border: "none"}}
                    >
                        {getMappedClassOptions()}
                    </SelectField>
                </div>
                <ClassMenu
                    isOpen={isViewingClassMenu}
                    handleAddClick={handleAddClick}
                    addClicked={addClicked}
                    possibleClasses={possibleClasses && possibleClasses.filter(classObject =>
                        // students may only join Active classes; the endpoint also returns Closed ones
                        classObject.status === "Active" && !user.classes.includes(classObject._id))}
                    userId={user._id}
                    addClass={addClassToUser}
                    removeClass={handleRemoveClick}
                    classId={classObject._id}
                    closeMenu={toggleClassMenu}
                    userClasses={user.classes}
                    getClassesAssignments={getClassesAssignments}
                    getClassesSprints={getClassesSprints}
                    getClassesFromIds={getClassesFromIds}
                    classIndex={classIndex}
                    setClassIndex={handleClassIndexChange}
                />
                <div className="classMenu" onClick={toggleClassMenu}>
                    <i className="fa fa-ellipsis-v" style={{textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)"}}></i>
                </div>
            </div>
            <h1>Hi {user.firstName},</h1>
            <h2>{evaluationsLeftText}</h2>
            <div className="greyBar" style={{zIndex: 0}}>
                <div className="pinkBar" style={{zIndex: 2, boxShadow: "0 0 0 0"}}>
                    <h4>Submitted: {numberOfSubmittedEvaluations}/{totalNumberOfEvaluations}</h4>
                </div>
                <div className="pinkBar" style={pinkBarStyle}></div>
            </div>
            <div className="reviewHeaders">
                <h3 className="left">Reviews to Submit</h3>
                <h3 className="right"><Link to="/student/submitted" className="link">View Submitted Reviews {'>'}</Link></h3>
            </div>
            <div className="tiles">
                {mapNewReviews(evaluationsToDo.newEvaluationsToDo)}
            </div>
            <button className="actionButton" onClick={() => setClassStudentsAndRedirect(classObject._id)}>
                Add evaluation
            </button>
            <h3>Graded Reviews</h3>
            <div className="tiles">
                {mapEditReviews(evaluationsToDo.evaluationsToEdit)}
            </div>
            <h3>Reports</h3>
            <div className="tiles">
                {getMappedReports(classObject)}
            </div>
            
            {/* Remove Class Confirmation Dialog */}
            <Dialog
                open={showRemoveDialog}
                onRequestClose={handleCancelRemove}
                contentStyle={{ maxWidth: '400px' }}
            >
                <div style={{ padding: '20px' }}>
                    <h3 style={{ marginTop: '0', marginBottom: '15px', color: '#333' }}>
                        Remove Class
                    </h3>
                    <p style={{ marginBottom: '20px', color: '#666' }}>
                        Are you sure you want to remove <strong>{classToRemove?.className}</strong> from your classes?
                    </p>
                    <p style={{ marginBottom: '25px', color: '#999', fontSize: '14px' }}>
                        This action will remove you from the class and you won't be able to access its assignments or evaluations.
                    </p>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end', 
                        gap: '10px' 
                    }}>
                        <FlatButton 
                            label="Cancel"
                            onClick={handleCancelRemove}
                        />
                        <FlatButton 
                            label="Remove Class"
                            primary={true}
                            onClick={handleConfirmRemove}
                            style={{ color: '#ef6a6e' }}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, { removeClassFromUser, addClassToUser, getReviewingStudentEvaluations, getClassesAssignments, setAssignment, getClassesSprints, getClassesFromIds, setSprint, getClassStudents, getSprintEvaluations, getPossibleClasses, setEvaluation, fetchServerTime })(Student);
